<template>
  <modal-container :id="id" small>
    <form @submit.prevent>
      <div class="modal-header">
        <h5 class="modal-title">Add Document</h5>
      </div>
      <div class="modal-body">
        <base-field label="Name">
          <base-input v-model="caption" placeholder="name" required />
        </base-field>
        <base-checkbox v-model="sent">
          Sent to Borrower
        </base-checkbox>
        <base-checkbox v-model="requiresSignature">
          Requires Signature
        </base-checkbox>
        <base-checkbox v-model="requiresInternalSignature">
          Requires Internal Signature
        </base-checkbox>
      </div>
      <div class="modal-footer">
        <base-button data-dismiss="modal">
          Cancel
        </base-button>
        <button-upload
          :caption="caption"
          :requires-internal-signature="requiresInternalSignature"
          :requires-signature="requiresSignature"
          primary
          :sent="sent"
          :tag="tag"
          @uploaded="uploaded">
          Upload File
        </button-upload>
      </div>
    </form>
  </modal-container>
</template>

<script>
import ButtonUpload from './ButtonUpload.vue'
import ModalContainer from './ModalContainer.vue'

export default {
  data: () => ({
    caption: '',
    requiresInternalSignature: false,
    requiresSignature: false,
    sent: false
  }),

  name: 'AddProjectDocument',

  components: {
    ButtonUpload,
    ModalContainer
  },

  props: {
    id: String,
    tag: String
  },

  methods: {
    async uploaded (document) {
      await this.$store.dispatch('core/projects/documents/add', document)

      this.$modal.close(`#${this.id}`)

      this.$flash.success('Document successfully uploaded.')
    }
  }
}
</script>
